export default {
      id: "ic-nav-send-usage",
      viewBox: "0 0 26 26",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-nav-send-usage",
      toString: function () {
        return this.url;
      }
    }